import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '@auth0/auth0-angular';
import { firstValueFrom } from 'rxjs';
import { routeUrls } from '../constants/constants';
import { UtmService } from '../services/utm.service';

/**
 * Public-route guard for /register-club: a signed-in user goes to the dashboard instead of
 * seeing the new-club registration modal. Never blocks a signed-out visitor.
 * Browser only, so the prerender build neither touches Auth0 nor redirects.
 */
export const SignedInRedirectGuard: CanActivateFn = async () => {
  if (!isPlatformBrowser(inject(PLATFORM_ID))) {
    return true;
  }
  // Injecting UtmService captures ?utm_* into sessionStorage (ct_utm_params) in its constructor,
  // so campaign attribution survives the redirect.
  inject(UtmService);
  const auth = inject(AuthService);
  const router = inject(Router);

  const isAuthenticated = await firstValueFrom(auth.isAuthenticated$);
  return isAuthenticated ? router.createUrlTree(['/', routeUrls.DASHBOARD]) : true;
};
